import { render, staticRenderFns } from "./orderDetailInfo.vue?vue&type=template&id=6a6ef6f9"
import script from "./orderDetailInfo.vue?vue&type=script&lang=js"
export * from "./orderDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./orderDetailInfo.vue?vue&type=style&index=0&id=6a6ef6f9&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a6ef6f9')) {
      api.createRecord('6a6ef6f9', component.options)
    } else {
      api.reload('6a6ef6f9', component.options)
    }
    module.hot.accept("./orderDetailInfo.vue?vue&type=template&id=6a6ef6f9", function () {
      api.rerender('6a6ef6f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/components/orderDetailInfo.vue"
export default component.exports